module.exports = __webpack_public_path__ + "static/media/logo.4258dccd.jpg";